export default {
  title: 'Informazioni personali',
  buttons: {
    save: 'Salva',
  },
  toasts: {
    personal_info_updated_successfully: 'Informazioni salvate con successo',
  },
};
